module.exports = __webpack_public_path__ + "img/Rcode.6b3a74c4.jpg";